
















import { computed, defineComponent, useRoute } from '@nuxtjs/composition-api';
import { useEnotecaApp } from '~/composables/useEnotecaApp';
import { useFirstPurchasePromotion } from '~/composables/useFirstPurchasePromotion';
import { useStore } from '~/composables/useStore';
import { url } from '~/utils';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();
    const { isEnotecaAppWebView } = useEnotecaApp();
    const { hasClosedPromo, showLogosOnly } = useFirstPurchasePromotion();

    const authenticated = computed(() => store.state.auth.authenticated);

    // 表示対象フラグ（商品一覧/生産者一覧/特集一覧＋✕ボタンの閉じるsessionなし＋未ログイン）
    const isInsideFirstPurchasePromoRange = computed(() => {
      const path = route.value.path;
      return (
        [url('ITEM_LIST'), url('PRODUCER_LIST'), url('ARCHIVES_LIST')].includes(path) &&
        !hasClosedPromo.value &&
        !authenticated.value
      );
    });

    const handleClick = () => emit('click');

    return {
      isEnotecaAppWebView,
      handleClick,
      hasClosedPromo,
      showLogosOnly,
      authenticated,
      isInsideFirstPurchasePromoRange,
    };
  },
});
